module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot2-88ff737c61c57f3317437eba6bcc50d8.png";